module.exports = "/_next/static/images/LeverageEvents@2x-579179cc2898a03e84877977679ee1af.webp";